// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssetCostCenterLocationDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class AssetCostCenterLocationApiClient extends BaseCRUDApiClient<AssetCostCenterLocationDto> {
  baseUrl = this.config.apiEndpoint + '/asset-cost-center-location';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
